import { render } from "./AuthorizedContacts.vue?vue&type=template&id=2da49da8&ts=true"
import script from "./AuthorizedContacts.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContacts.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__